import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackEvent } from './analytics';

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent({
      event: 'virtual_page_view',
      page_path: window.location.pathname + window.location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}

